<template>
    <div class="w-full">
        <div class="w-full xl:w-1/2 mx-auto">
            <div class="w-full h-64 mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Tahap 2 - Pemesanan <br />
                    UMUM
                </h1>
                <!-- Data Pasien -->
                <PasienCard :pasien="pasien" />
            </div>
            <!-- Form -->
            <div class="w-full mt-64 md:mt-52">
                <form @submit.prevent="regis">
                    <div class="w-full mt-5">
                        <TextInput
                            v-model="form.nik"
                            :error="form.errors.nik"
                            class="w-full"
                            id="nik"
                            label="NIK"
                            type="text"
                        />
                    </div>
                    <div class="w-full mt-5">
                        <TextInput
                            v-model="form.no_hp"
                            :error="form.errors.no_hp"
                            class="w-full"
                            id="no_hp"
                            label="NO HP"
                            type="text"
                        />
                    </div>
                    <div class="w-full mt-5">
                        <SelectInput
                            v-model="form.poli"
                            :error="form.errors.poli"
                            :custError="
                                $page.props.errors.getDokter
                                    ? $page.props.errors.getDokter.poli
                                    : ''
                            "
                            id="poli"
                            label="poli"
                        >
                            <option value="">=== PILIH POLI ===</option>
                            <option
                                v-for="poli in polis"
                                :key="poli.FS_KD_LAYANAN"
                                :value="poli.FS_KD_LAYANAN"
                            >
                                {{ poli.FS_NM_LAYANAN }}
                            </option>
                        </SelectInput>
                    </div>
                    <div class="w-full mt-5 flex">
                        <DateInput
                            v-model="form.tgl_periksa"
                            :error="form.errors.tgl_periksa"
                            :custError="
                                $page.props.errors.getDokter
                                    ? $page.props.errors.getDokter.tgl_periksa
                                    : ''
                            "
                            class="w-full grow mr-5"
                            id="tgl_periksa"
                            label="PILIH TANGGAL"
                        />
                        <button
                            @click.prevent="getDokter"
                            class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs"
                        >
                            LIHAT DOKTER
                        </button>
                    </div>
                    <div v-if="jadwalDokter">
                        <div
                            v-if="jadwalDokter.statusJadwalDokter == '000'"
                            class="border border-solid border-black p-3 rounded-lg mt-5"
                        >
                            <p class="text-lg text-center mt-2 mb-5">
                                DATA DOKTER
                            </p>
                            <div
                                v-for="jadwalDokter in jadwalDokter.jadwalDokterRes"
                                :key="jadwalDokter.kode_dokter"
                                class="w-full bg-green-300 h-40 rounded-lg p-5 mt-5"
                            >
                                <h1 class="font-bold text-2xl text-black">
                                    {{ jadwalDokter.nama_dokter }}
                                </h1>
                                <p
                                    class="font-semibold text-xl text-purple-800 mt-5"
                                >
                                    {{ jadwalDokter.jam_praktik }}
                                </p>

                                <button
                                    @click.prevent="
                                        setDokter(
                                            jadwalDokter.kode_dokter,
                                            jadwalDokter.nama_dokter,
                                            jadwalDokter.jam_praktik
                                        )
                                    "
                                    class="btn-green ml-auto w-36 h-10"
                                >
                                    Pilih
                                </button>
                            </div>
                            <div
                                class="w-full bg-green-300 h-48 rounded-lg p-5 mt-5"
                            >
                                <h1
                                    class="font-bold text-2xl text-black text-center"
                                >
                                    DOKTER DIPILIH
                                </h1>
                                <h1 class="font-bold text-xl text-black mt-5">
                                    {{
                                        dokterSelected
                                            ? dokterSelected.nama_dokter
                                            : ""
                                    }}
                                </h1>
                                <p
                                    class="font-semibold text-xl text-purple-800 mt-2"
                                >
                                    {{
                                        dokterSelected
                                            ? dokterSelected.jam_praktik
                                            : ""
                                    }}
                                </p>

                                <button
                                    v-if="dokterSelected"
                                    @click.prevent="resetDokter()"
                                    class="btn-red ml-auto w-36 h-10"
                                >
                                    Reset
                                </button>
                            </div>
                            <div
                                v-if="form.errors.dokter"
                                class="mt-2 text-red-500 h-8"
                            >
                                {{ form.errors.dokter }}
                            </div>
                        </div>
                    </div>
                    <div v-if="jadwalDokter" class="w-full mt-2">
                        <div
                            v-if="jadwalDokter.statusJadwalDokter == '999'"
                            class="w-full h-6 flex items-center bg-red-600 p-2 rounded-lg text-white"
                        >
                            {{ jadwalDokter.statusJadwalDokterMsg }}
                        </div>
                    </div>
                    <FlashMessage class="mt-5" />
                    <div class="w-full mt-5">
                        <button
                            type="submit"
                            class="bg-teal-400 hover:bg-teal-700 h-16 rounded-3xl mt-8 w-full text-white m-auto"
                        >
                            DAFTAR
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutNoHeader from "../../Shared/LayoutNoHeader.vue";
import TextInput from "../../Shared/TextInput.vue";
import DateInput from "../../Shared/DateInput.vue";
import SelectInput from "../../Shared/SelectInput.vue";
import FlashMessage from "../../Shared/FlashMessage.vue";
import PasienCard from "../../Shared/PasienCard.vue";

export default {
    props: {
        pasien: Object,
        polis: Object,
    },
    components: {
        Link,
        TextInput,
        DateInput,
        SelectInput,
        FlashMessage,
        PasienCard,
    },
    layout: LayoutNoHeader,
    data() {
        return {
            form: this.$inertia.form({
                no_rm: this.pasien.FS_MR,
                nik: this.pasien.FS_KD_IDENTITAS,
                no_hp: this.pasien.FS_TLP_PASIEN,
                poli: "",
                tgl_periksa: "",
                dokter: "",
            }),
            dokterSelected: "",
            jadwalDokter: "",
        };
    },
    computed: {
        formPoli(){
            return this.form.poli;
        },
        formTglPeriksa(){
            return this.form.tgl_periksa;
        }
    },  
    watch: {
        formPoli(){
            this.resetJadwalDokter();
        },
        formTglPeriksa(){
            this.resetJadwalDokter();
        }
    },  
    methods: {
        regis() {
            const confirm = window.confirm(
                "Pastikkan data sudah benar, Yakin Anda akan menyimpan data booking tersebut?"
            );
            if (confirm == 1) {
                this.form.post("/self_regis", { preserveScroll: true });
            }
        },
        getDokter() {
            this.resetDokter();
            this.$inertia.post(
                "/jadwal_dokter",
                {
                    poli: this.form.poli,
                    tgl_periksa: this.form.tgl_periksa,
                },
                {
                    preserveScroll: true,
                    onSuccess: (page) => {
                        this.jadwalDokter = page.props.additional.jadwalDokter;
                    },
                    errorBag: "getDokter",
                }
            );
        },
        resetJadwalDokter(){
            this.resetDokter();
            this.jadwalDokter = "";
        },
        setDokter(kdDokter, nmDokter, jmPraktik) {
            this.form.dokter = kdDokter;
            this.dokterSelected = {
                nama_dokter: nmDokter,
                jam_praktik: jmPraktik,
            };
        },
        resetDokter() {
            this.form.dokter = "";
            this.dokterSelected = "";
        },
    },
};
</script>
